import { makeAutoObservable } from "mobx";

export class Step {
  activeStep = 0;
  completedStep: Record<number, boolean> = {
    0: false,
    1: false,
  };

  constructor() {
    makeAutoObservable(this);
  }

  // Getters
  get hasPreviousStep(): boolean {
    return this.activeStep === 1;
  }

  get hasNextStep(): boolean {
    return this.activeStep === 0;
  }

  // Setters
  set setStep(index: number) {
    this.activeStep = index;
  }

  // Methods
  nextStep = (): void => {
    this.activeStep = 1;
    this.completedStep = { ...this.completedStep, 0: true };
  };

  previousStep = (): void => {
    this.activeStep = 0;
  };
}
